import { useEffect, useRef } from "react";
import { useReducedMotion } from "framer-motion";

const DepthLayer = () => {
  const ref=useRef<HTMLDivElement>(null); const reduced=useReducedMotion();
  useEffect(()=>{ if(reduced||window.innerWidth<700)return; let frame=0; const move=()=>{ if(frame||document.hidden)return; frame=requestAnimationFrame(()=>{ if(ref.current)ref.current.style.transform=`translate3d(0,${window.scrollY*.25}px,0)`; frame=0; });}; window.addEventListener("scroll",move,{passive:true}); return()=>{window.removeEventListener("scroll",move);cancelAnimationFrame(frame);};},[reduced]);
  return <div ref={ref} className="depth-grid" aria-hidden />;
};
export default DepthLayer;